import { createContext, useCallback, useState } from "react";
import API from "services/api";

export const ContentContext = createContext({});

const ContentProvider = (props) => {
  const [dataContent, setDataContent] = useState({});
  const [contents, setContents] = useState([]);
  const [totalCount, setTotalCount] = useState(0);
  const [categories, setCategories] = useState([]);
  const [category, setCategory] = useState({});
  const [dataTags, setDataTags] = useState([]);
  const [dataMembership, setDataMembership] = useState({});

  // photos & videos
  const [photos, setPhotos] = useState([]);
  const [videos, setVideos] = useState([]);
  const [dataVideo, setDataVideo] = useState({});

  // list editor
  const [listEditor, setListEditor] = useState([]);

  // list categories
  const getListEditorContentCategories = useCallback(
    async (id, params) => {
      await API.getListEditorContentCategories(id, params)
        .then((res) => {
          const { type } = params;
          const { data } = res;
          setListEditor(data[type]);
        })
        .catch((err) => console.log("err", err));
    },
    [listEditor]
  );

  const getVideos = useCallback(async (params) => {
    await API.getAllVideo(params)
      .then((res) => {
        const { data, totalCount } = res.data;

        setVideos(data);
        setTotalCount(totalCount);
      })
      .catch((err) => console.log("err ", err));
  }, []);

  const getPhotos = useCallback(async (params) => {
    await API.getAllPhoto(params)
      .then((res) => {
        const { data, totalCount } = res.data;

        setPhotos(data);
        setTotalCount(totalCount);
      })
      .catch((err) => console.log("err ", err));
  }, []);

  const getVideoCategories = useCallback(async (params) => {
    await API.getContentCategories(params)
      .then((res) => {
        const { data } = res.data;
        setCategories(data);
      })
      .catch((err) => console.log("err ", err));
  }, []);

  const getPhotoCategories = useCallback(async (params) => {
    await API.getContentCategories(params)
      .then((res) => {
        const { data } = res.data;
        setCategories(data);
      })
      .catch((err) => console.log("err ", err));
  }, []);

  const getCategories = useCallback(async (params) => {
    await API.getContentCategories(params)
      .then((res) => {
        const { data } = res.data;
        setCategories(data);
      })
      .catch((err) => console.log("err ", err));
  }, []);

  const getCategory = useCallback(async (id, params) => {
    await API.getContentCategory(id, params)
      .then((res) => {
        const { data } = res.data;
        setCategory(data[0]);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getAllContent = useCallback(async (params) => {
    await API.getAllContent(params)
      .then((res) => {
        const { data, totalCount: _totalCount } = res.data;
        // console.log("total", total);
        setTotalCount(_totalCount);
        setContents(data);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getDataContent = useCallback(async (id, params) => {
    await API.getContent(id, params)
      .then((res) => {
        const data = res.data;
        // console.log("data", data);
        const category = data[0].category?._id;
        const newData = { ...data[0], category };
        setDataContent(newData);
      })
      .catch((err) => console.log("err", err));
  }, []);

  const getMemberContent = useCallback(async (params) => {
    try {
      const { status, ...otherParams } = params; 
      const res = await API.getMembershipByStatus(status, otherParams);
      console.log("API Response:", res);
      const { data, totalCount } = res.data;
  
      setDataMembership(data);
      setTotalCount(totalCount);
    } catch (err) {
      console.log("err", err);
    }
  }, []);


  return (
    <ContentContext.Provider
      value={{
        dataContent,
        contents,
        category,
        categories,
        dataTags,
        totalCount,
        photos,
        videos,
        dataVideo,
        listEditor,
        dataMembership,

        getPhotos,
        getVideos,
        getVideoCategories,
        getPhotoCategories,
        setDataTags,
        getCategories,
        getCategory,
        getAllContent,
        getDataContent,
        getListEditorContentCategories,
        getMemberContent,
      }}
      {...props}
    />
  );
};

export default ContentProvider;
